import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight, Wand2 } from "lucide-react";

export default function VisualizePromo() {
  return (
    <section className="bg-ink py-24 md:py-32 border-t border-white/10" id="vizualizacia">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="relative border border-gold/30 bg-ink-2 overflow-hidden grid grid-cols-1 lg:grid-cols-2">
          <div className="absolute inset-0 opacity-20 lg:opacity-30">
            <img src="https://images.pexels.com/photos/1396132/pexels-photo-1396132.jpeg?auto=compress&cs=tinysrgb&w=1400" alt="" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-transparent" />
          </div>
          <div className="relative z-10 p-8 md:p-14">
            <div className="inline-flex items-center gap-2 text-gold font-mono2 uppercase tracking-[0.3em] text-xs mb-6">
              <Sparkles className="w-4 h-4" /> Novinka · Zadarmo
            </div>
            <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
              className="font-display text-4xl md:text-6xl text-white leading-[0.95]">
              Uvidíte svoju fasádu<br /><span className="text-gold">skôr, než ju zaplatíte</span>
            </motion.h2>
            <p className="text-white/70 mt-6 max-w-md leading-relaxed">
              Nahrajte fotku domu alebo bytovky, vyberte farby a naša AI vám do minúty pripraví
              3 realistické návrhy novej zateplenej fasády — úplne zadarmo a nezáväzne.
            </p>
            <Link to="/vizualizacia" data-testid="home-visualize-cta"
              className="inline-flex items-center gap-3 mt-8 bg-gold text-ink px-8 py-4 font-bold uppercase tracking-wider hover:bg-gold-light transition-colors group">
              <Wand2 className="w-5 h-5" /> Vyskúšať vizualizáciu
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
          <div className="hidden lg:block" />
        </div>
      </div>
    </section>
  );
}
